import React from 'react'
import { FeatureImage, FeatureImageType } from 'js/components/FeatureImage'

type Props = {
  image: FeatureImageType
  title: string
  description: string
  className?: string
}

const Card = ({ image, title, description }: Props) => {
  return (
    <div className="flex h-full flex-col items-center rounded-16 bg-white p-16 lg:flex-col lg:px-16 lg:py-23">
      <div className="mb-24 h-[150px]">
        <FeatureImage
          image={image}
          className="order-1 h-full rounded-6 object-cover lg:mx-auto"
        />
      </div>
      <div className="order-1 w-full lg:order-1">
        <h3 className="type-14-bold lg:type-17-bold">{title}</h3>
        <p className="leading-21 type-14-demibold lg:type-17-demibold">
          {description}
        </p>
      </div>
    </div>
  )
}

export default Card
